import { Link } from '@tanstack/react-router';

import { useAuth } from '@/auth/useAuth';
import { Button, Icon } from '@/components/ui';

// Full-page screen shown to authenticated users who have no active memberships.
// Rendered from __root.tsx before the sidebar shell, so no tenant-scoped queries
// are issued from this branch. Super-admins can enter every tenant, so they only
// see this when no tenant exists yet and get a path into /admin to create one.
export function NoTenantAccess({ isSuperAdmin = false }: { isSuperAdmin?: boolean }) {
  const { logout } = useAuth();
  return (
    <div
      role="alert"
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <Icon name="shield" size={36} style={{ color: 'var(--text-3)' }} />
      <h1 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>No tenant access</h1>
      <p style={{ margin: 0, maxWidth: 380, color: 'var(--text-2)', fontSize: 13.5, lineHeight: 1.5 }}>
        {isSuperAdmin
          ? 'No tenant exists yet. Open tenant administration to create one.'
          : 'You don’t have access to any tenant yet. Ask an administrator to invite you, then sign in again.'}
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        {isSuperAdmin && (
          <Link to="/admin/tenants">
            <Button variant="primary" leftIcon={<Icon name="shield" size={14} />}>
              Open tenant administration
            </Button>
          </Link>
        )}
        <Button variant="secondary" leftIcon={<Icon name="logout" size={14} />} onClick={() => void logout()}>
          Sign out
        </Button>
      </div>
    </div>
  );
}
